<div class="ib-ng-accordion" [ngStyle]="style" [ngClass]="styleClass" role="tablist">
    <ng-content></ng-content>
</div>
